var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRtLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.25 40H11.8692C11.4465 40 11.0354 39.858 10.6986 39.5956C9.84593 38.9321 9.67887 37.6848 10.3254 36.8099L16.6104 30.4297C16.6105 30.4297 19.8238 33.6198 26.25 40Z",
    fill: "#FF4F12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.74998 36.8V12.2528C8.74998 10.8072 9.3032 9.4176 10.294 8.3744L18.25 0L32.5 14.4L10.532 36.6128C10.1626 36.9848 9.95482 37.4904 9.95482 38.0176C9.95482 39.1128 10.8332 40 11.9167 40C10.1678 40 8.74998 38.5672 8.74998 36.8Z",
    fill: "#7700FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRtLogo);
export default __webpack_public_path__ + "static/media/rt-logo.e7a22e1a0643185903a6de12323f4212.svg";
export { ForwardRef as ReactComponent };